import { useContext } from "react";
import { Redirect } from "react-router";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";
import { parseParams } from "utilities/url/url";

import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IDailyLogProps } from "entity/dailyLog/DailyLog/DailyLog";
import { type IDailyLogCreationData } from "entity/dailyLog/DailyLog/DailyLog.api.types";

const DailyLog = lazyLoadComponent(() => import("./DailyLog"));

interface IRouteDailyLogProps extends Omit<IDailyLogProps, "id" | "jobId"> {
    prefilledFormValues?: IDailyLogCreationData;
}

export const RouteDailyLog = (props: IRouteDailyLogProps) => {
    const builderInfo = useContext(BuilderInfoContext);

    return (
        <RouteRelative
            path={routes.dailyLog.details}
            render={(routeProps) => {
                const params = routeProps.match.params as { id: string; jobId: string };
                const id = parseInt(params.id);
                const jobId = parseInt(params.jobId);

                if (builderInfo?.flags.dailyLogsModalConversion) {
                    const subPath = routeProps.location.pathname.slice(routeProps.match.url.length);
                    return <Redirect to={routes.dailyLog.getViewStateLink(id, jobId) + subPath} />;
                }

                const qsParams = parseParams<{ openWithMap: string }>(routeProps.location.search);
                const isOpenWithMap = qsParams.openWithMap === "true";

                return (
                    <DailyLog
                        {...props}
                        {...routeProps}
                        id={id}
                        jobId={jobId}
                        isOpenWithMap={isOpenWithMap}
                    />
                );
            }}
        />
    );
};
